import { WidgetPreviewState } from '../features/widget-preview-slice';
import { RootState } from '../store';

export const selectWidgetPreview: (state: RootState) => WidgetPreviewState = state => state.widgetPreview;